import {
  Button,
  Divider,
  DividerVariants,
  Iconography,
  IconographySizes,
  InlineStatus,
  InlineStatusAppearance,
  InlineStatusIconType,
} from "@hid-galaxy-ui/galaxy-react";
import moment from "moment";
import React from "react";
import InvoiceGenerator from "../InvoiceGenerator";
import { OrderListType } from "../../../redux/slices/my-account/Types";
import { usePartnerSessionCanAccessModule } from "../../../hooks/usePartnerSessionPermissions";
import { useSessionCanAccessModule } from "../../../hooks/useSessionPermissions";
import { PARTNER_PORTAL_PERMISSION_KEYS as PP_KEYS } from "../../../utils/permissions/partnerPortalPermissionKeys";
import { PARTNER_MANAGEMENT_PERMISSION_KEYS as PM_KEYS } from "../../../utils/permissions/partnerManagementPermissionKeys";
import "./OrderHistoryCard.scss";

export type OrderHistoryPermissionScope = "admin" | "partner";

const OrderHistoryCard: React.FC<{
  order: OrderListType;
  onCardClick: (orderId: string) => void;
  permissionScope: OrderHistoryPermissionScope;
}> = ({ order, onCardClick, permissionScope }) => {
  const canAccessAdminOrders = useSessionCanAccessModule(
    PM_KEYS.ADMIN_ORDER_MANAGEMENT
  );
  const canAccessPartnerOrders = usePartnerSessionCanAccessModule(
    PP_KEYS.PARTNER_ORDER_MANAGEMENT
  );
  const canDownloadPdf =
    permissionScope === "admin" ? canAccessAdminOrders : canAccessPartnerOrders;
  let temp = order.id.split("/");
  const orderID = temp[temp.length - 1].split("?")[0];
  const orderStatus = (status: string) => {
    if (status === "FULFILLED") {
      return (
        <InlineStatus
          label={status.toLowerCase()}
          appearance={InlineStatusAppearance.Positive}
          iconType={InlineStatusIconType.Dot}
        />
      );
    } else {
      return (
        <InlineStatus
          label={status.split("_").join(" ").toLowerCase()}
          appearance={InlineStatusAppearance.Caution}
          iconType={InlineStatusIconType.Dot}
        />
      );
    }
  };
  return (
    <div className="order-history-card" key={order.id}>
      <div className="icon-info">
        <Iconography icon="circleCheck" size={IconographySizes.Medium} />
        <div className="info">
          <div className="name">{order.name}</div>
          <div className="detail">
            <span>{orderID}</span>
            <Divider mode={DividerVariants.Content} />
            <span>
              {moment(order.processedAt).format("DD MMM YYYY, HH:mm")}
            </span>
          </div>
        </div>
        <div className="order-status">
          <label>Order Status</label>
          <div className="status-value">
            {orderStatus(order.displayFulfillmentStatus)}
          </div>
        </div>
      </div>
      <div className="button-group">
        <Button
          variant="secondary"
          label="View Details"
          onClick={() => onCardClick(order.id)}
        />
        <Divider mode={DividerVariants.Content} />
        <InvoiceGenerator
          orderID={order.id}
          showInvoice={false}
          downloadDisabled={!canDownloadPdf}
        />
      </div>
    </div>
  );
};

export default OrderHistoryCard;
